import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import MachinesSection from '../components/MachinesSection';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { productsAPI, settingsAPI } from '../services/api';

const Home = () => {
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [productsData, settingsData] = await Promise.all([
        productsAPI.getAll(),
        settingsAPI.get(),
      ]);
      setProducts(productsData);
      setSettings(settingsData);
    } catch (error) {
      console.error('Error loading data:', error);
      // Fall back to mock data if API fails
      const { products: mockProducts, companyInfo } = require('../data/mock');
      setProducts(mockProducts);
      setSettings(companyInfo);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="text-xl text-stone-600">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection settings={settings} />
        <MachinesSection products={products} />
        <AboutSection settings={settings} />
        <ContactSection />
      </main>
      <Footer settings={settings} />
      <WhatsAppButton settings={settings} />
    </div>
  );
};

export default Home;
